import { render, staticRenderFns } from "./BridgeForm.vue?vue&type=template&id=22fe56e9&scoped=true"
import script from "./BridgeForm.vue?vue&type=script&lang=js"
export * from "./BridgeForm.vue?vue&type=script&lang=js"
import style0 from "./BridgeForm.vue?vue&type=style&index=0&id=22fe56e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fe56e9",
  null
  
)

export default component.exports